import BroadcastConfigForm from "../../components/admin/brodcasting-management/BroadcastConfigForm";

const BroadcastConfigFormPage = () => {
  return (
    <>
      <BroadcastConfigForm />
    </>
  );
};

export default BroadcastConfigFormPage;
